import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalMultiuploadPluginComponent } from './modal-multi-upload/modal-multi-upload.component';
import { ModalUploadPluginComponent } from './modal-upload/modal-upload.component';

@Component({
    selector: 'asap-upload',
    templateUrl: './asap-upload.component.html',
    styles: ['./asap-upload.component.css']
})
export class AsapUploadComponent implements OnInit {


    @Input() horizontal;
    @Input() aspectRatio;
    @Input() resizeToWidth;
    @Input() type;
    @Input() multiple;
    @Input() onlyType;
    @Input() uploadType = 'cloudinary';
    @Input() btnClass = 'btn btn-default btn-xs';
    @Input() btnTitle = 'ADICIONAR ARQUIVO';

    @Output() AddPhoto: EventEmitter<any> = new EventEmitter<any>();
    @Output() AddArchive: EventEmitter<any> = new EventEmitter<any>();
    @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();




    constructor(
        public dialog: MatDialog
    ) { }

    ngOnInit() {

    }

    public openDialog(): void {
        if (this.multiple) {
            const dialogRef = this.dialog.open(ModalMultiuploadPluginComponent, {
                width: '800px',
                maxWidth: '800px',
                //   height: '90vh',
                disableClose: true,
                data: {
                    type: this.type,
                    resizeToWidth: this.resizeToWidth,
                    aspectRatio: this.aspectRatio,
                    horizontal: this.horizontal,
                    multiple: this.multiple,
                    onlyType: this.onlyType
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    if (this.type === 'image') {
                        this.AddPhoto.emit(result);
                    } else {
                        this.AddArchive.emit(result);
                    }
                }
                else {
                    this.onCancel.emit();
                }
            });
        } else {
            const dialogRef = this.dialog.open(ModalUploadPluginComponent, {
                width: '800px',
                maxWidth: '800px',
                maxHeight: '800px',
                id: 'modalUpload',
                disableClose: true,
                data: {
                    type: this.type,
                    resizeToWidth: this.resizeToWidth,
                    aspectRatio: this.aspectRatio,
                    horizontal: this.horizontal,
                    multiple: this.multiple,
                    onlyType: this.onlyType,
                    uploadType: this.uploadType
                }
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    if (this.type === 'image') {
                        this.AddPhoto.emit(result);
                    } else {
                        this.AddArchive.emit(result);
                    }
                }
                else {
                    this.onCancel.emit();
                }
            });
        }
    }

}
